import { Injectable } from '@angular/core';
import CryptoJS from 'crypto-es';

import { constants } from '@shared/constants/app-constants';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  public setItem(key: string, value: unknown): void {
    const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), constants.ENCRYPTION_KEY).toString();
    sessionStorage.setItem(key, encryptedValue);
  }

  public getItem<T>(key: string): T | undefined {
    const storageValue = sessionStorage.getItem(key);
    if (!storageValue) {
      return undefined;
    }

    const decryptedValue = CryptoJS.AES.decrypt(storageValue, constants.ENCRYPTION_KEY);
    const value = decryptedValue.toString(CryptoJS.enc.Utf8);

    if (value) {
      return JSON.parse(decryptedValue.toString(CryptoJS.enc.Utf8));
    } else {
      return undefined;
    }
  }

  public removeItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  public isKeyExist(key: string): boolean {
    return sessionStorage.getItem(key) !== null;
  }
}
